import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import './RegisterForm.css';

interface FormData {
  name: string;
  email: string;
  age: string;
  gender: string;
  phone: string;
}

const RegisterForm: React.FC = () => {
  const navigate = useNavigate();

  const [formData, setFormData] = useState<FormData>({
    name: '',
    email: '',
    age: '',
    gender: '',
    phone: '',
  });

  const [queryId, setQueryId] = useState<string>('');
  const [message, setMessage] = useState<string>('');
  const [createdId, setCreatedId] = useState<number | null>(null);
  const [loading, setLoading] = useState<boolean>(false);

  const apiBase = process.env.REACT_APP_API_URL || '';

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setMessage('');
    setCreatedId(null);

    try {
      const response = await axios.post(
        `${apiBase}/api/registration/register/`,
        {
          ...formData,
          age: Number(formData.age),
        }
      );

      const newId = response.data?.registration?.id ?? null;
      setCreatedId(newId);
      setMessage(
        newId
          ? `報名成功，您的報名編號是 ${newId}`
          : '報名成功'
      );

      setFormData({
        name: '',
        email: '',
        age: '',
        gender: '',
        phone: '',
      });
    } catch (error: any) {
      setMessage(error?.response?.data?.error || '報名失敗');
    } finally {
      setLoading(false);
    }
  };

  const handleQueryById = () => {
    if (!queryId.trim()) {
      setMessage('請輸入要查詢的 ID');
      return;
    }
    navigate(`/update/${queryId}`);
  };

  const handleViewList = () => {
    navigate('/registrations');
  };

  return (
    <div className="register-form-container">
      <h2>森林學校報名表</h2>

      {message && <p className="message">{message}</p>}

      <form onSubmit={handleSubmit} className="register-form">
        <input
          type="text"
          name="name"
          placeholder="姓名"
          value={formData.name}
          onChange={handleChange}
          required
        />

        <input
          type="email"
          name="email"
          placeholder="Email"
          value={formData.email}
          onChange={handleChange}
          required
        />

        <input
          type="number"
          name="age"
          placeholder="年齡"
          value={formData.age}
          onChange={handleChange}
          required
        />

        <select
          name="gender"
          value={formData.gender}
          onChange={handleChange}
          required
        >
          <option value="">請選擇性別</option>
          <option value="Male">男</option>
          <option value="Female">女</option>
          <option value="Other">其他</option>
        </select>

        <input
          type="text"
          name="phone"
          placeholder="電話"
          value={formData.phone}
          onChange={handleChange}
          required
        />

        <button type="submit" disabled={loading}>
          {loading ? '送出中...' : '送出報名'}
        </button>
      </form>

      {createdId && (
        <div style={{ marginTop: '1rem' }}>
          <button onClick={() => navigate(`/update/${createdId}`)}>
            查看剛建立的資料
          </button>
        </div>
      )}

      <div style={{ marginTop: '2rem' }}>
        <h3>用 ID 查詢 / 修改</h3>
        <input
          type="number"
          placeholder="請輸入報名 ID"
          value={queryId}
          onChange={(e) => setQueryId(e.target.value)}
        />
        <button type="button" onClick={handleQueryById}>
          依 ID 查詢
        </button>
      </div>

      <div style={{ marginTop: '1rem' }}>
        <button type="button" onClick={handleViewList}>
          查看全部報名資料
        </button>
      </div>
    </div>
  );
};

export default RegisterForm;